import {AppointmentBookingBaseComponent} from "../appointment-booking-base.component";
import {Component, OnInit} from "@angular/core";


@Component({
    selector: 'as-appointment-booking-full',
    templateUrl: 'appointment-booking-full.component.html',
    standalone: false
})
export class AppointmentBookingFullComponent extends AppointmentBookingBaseComponent implements OnInit{


    ngOnInit() {
        super.ngOnInit();
    }

}
